/*
 * Pestaña "Historial" de la ficha de tienda IGI: todas las evaluaciones de la tienda (mas reciente
 * primero) con su autor y tipo ("Zonal" o "Evaluación de dirección"); la vigente (la que define el IGI
 * actual) va marcada. Cada tarjeta se expande para ver notas por criterio, comentarios y observaciones.
 * "Corregir" aparece solo si el backend marca `puede_corregir` (el usuario es el autor y tiene permiso).
 * React escapa todo el texto (no se usa dangerouslySetInnerHTML).
 */
import React, {useState} from "react";
import Button from "../../../../components/button";
import {NivelBadge, formatoFecha, formatoNota, formatoValor} from "../niveles";

const Historial = ({evaluaciones, actualId, ejes, onCorregir}) => {
    const [abierta, setAbierta] = useState(null);
    const nombres = {};
    ejes.forEach((eje) => eje.criterios.forEach((c) => {
        nombres[c.id] = `${eje.codigo} · ${c.nombre}`;
    }));

    if (evaluaciones.length === 0) {
        return <div className="alert alert-info">La tienda todavía no tiene evaluaciones.</div>;
    }

    return (
        <div>
            {evaluaciones.map((ev) => (
                <div key={ev.id} className="card mb-1">
                    <div className="card-body p-1">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <strong>{formatoFecha(ev.fecha)}</strong>{" "}
                                <span className={`badge ${ev.es_de_zonal ? "badge-primary" : "badge-secondary"}`}>
                                    {ev.es_de_zonal ? "Zonal" : "Evaluación de dirección"}
                                </span>{" "}
                                {ev.id === actualId && <span className="badge badge-success">Vigente</span>}
                                <div className="small text-muted">{ev.autor.nombres || ev.autor.usuario}</div>
                            </div>
                            <div className="text-right">
                                <div style={{fontSize: "1.3rem", fontWeight: 700}}>{formatoNota(ev.igi)}</div>
                                <NivelBadge nivel={ev.nivel}/>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between small mt-50">
                            <span>E1 {formatoNota(ev.e1)}</span>
                            <span>E2 {formatoNota(ev.e2)}</span>
                            <span>E3 {formatoNota(ev.e3)}</span>
                        </div>
                        <div className="d-flex mt-50">
                            <Button
                                type="button"
                                theme="light"
                                classes="btn-sm mr-50"
                                text={abierta === ev.id ? "Ocultar detalle" : "Ver detalle"}
                                onChange={() => setAbierta(abierta === ev.id ? null : ev.id)}
                            />
                            {ev.puede_corregir && (
                                <Button
                                    type="button"
                                    theme="warning"
                                    classes="btn-sm"
                                    text={<><i className="bx bx-edit"/> Corregir</>}
                                    onChange={() => onCorregir(ev)}
                                />
                            )}
                        </div>
                        {abierta === ev.id && (
                            <div className="mt-1">
                                <ul className="list-unstyled small mb-1">
                                    {ev.notas.map((n) => (
                                        <li key={n.criterio} className="border-bottom py-25">
                                            {nombres[n.criterio] || `Criterio ${n.criterio}`}: <strong>{formatoValor(n.valor)}</strong>
                                            {n.comentario && <div className="text-muted">{n.comentario}</div>}
                                        </li>
                                    ))}
                                </ul>
                                {[["Observación", ev.observacion], ["Acción", ev.accion], ["Estrategia", ev.estrategia]]
                                    .filter(([, texto]) => texto)
                                    .map(([etiqueta, texto]) => (
                                        <p key={etiqueta} className="small mb-50" style={{whiteSpace: "pre-wrap"}}>
                                            <strong>{etiqueta}:</strong> {texto}
                                        </p>
                                    ))}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Historial;
